module.exports = __webpack_public_path__ + "img/blue.e7ab71c1.png";